import {ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnInit} from '@angular/core';
import {OccupationalProfile} from '../shared/occupational-profile';
import {ExternalReference} from '../shared/external-reference';
import {YoutubeIFrameApiService} from './youtube-iframe-api.service';

@Component({
    selector: 'occupational-profile-movie',
    templateUrl: './occupational-profile-movie.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class OccupationalProfileMovieComponent implements OnInit {

    @Input()
    public occupationalProfile!: OccupationalProfile;

    public failedToLoadVideo = false;

    constructor(
        private youtubeService: YoutubeIFrameApiService,
        private cdr: ChangeDetectorRef) {
    }

    ngOnInit(): void {
        if (this.hasMovie()) {
            const videoId = this.getYoutubeId(this.getFirstExternalMovieReference().url);
			if (videoId) {
				this.youtubeService.startVideo(videoId, 'player').subscribe({
					error: () => this.failedToLoadVideo = true
				}).add(() => this.cdr.detectChanges())
			}
        }
    }

    public hasMovie(): boolean {
        return this.getFirstExternalMovieReference()
            && !!this.getYoutubeId(this.getFirstExternalMovieReference().url)
            && !this.failedToLoadVideo;
    }

    private getFirstExternalMovieReference(): ExternalReference {
        return this.occupationalProfile.vdabSpecific.externalReferences
            .filter(externalReference => externalReference.type === 'MOVIE')[0];
    }

    private getYoutubeId(url: string): string | undefined {
        const regExp =
            /^(?:https?:\/\/)?(?:www\.)?(?:youtu\.be\/|youtube\.com\/(?:embed\/|v\/|watch\?v=|watch\?.+&v=))((\w|-){11})(?:\S+)?$/;
        const executedRegex = regExp.exec(url);
        return executedRegex ? executedRegex[1] : undefined;
    }
}
